/*
 * @Description: 登陆日志service
 * @Author: wangzhenxin (834529118@qq.com)
 * @Date: 2019-05-30 15:24:45
 * @LastEditTime: 2019-06-25 17:14:39
 * @LastEditors: wangzhenxin (834529118@qq.com)
 */
import { post } from '@/utils/request'
import { formatDateTime } from '@/utils/objectUtil'

/**
 * @description   获取登录日志列表
 * @param {*} params
 */
export async function getList (params) {
  const res = await post('/api/loginlog/showAllInfo', params)
  if (res.code === 'success') {
    res.data.list = res.data.list.map(({ loginTime, ...rest }) => ({
      ...rest,
      loginTime: formatDateTime(new Date(loginTime), 'yyyy-MM-dd HH:mm:ss'),
    }))
  }
  return res
}
/**
 * @description   删除登录日志
 * @param {*} params
 */
export async function deletesLoginLog (params) {
  return post('/api/loginlog/deletes', params)
}
